/**
 * Indian GST State Codes mapping.
 * The first 2 digits of an Indian GST number represent the state/UT code.
 */
export const GST_STATE_CODES = {
  "01": "Jammu and Kashmir",
  "02": "Himachal Pradesh",
  "03": "Punjab",
  "04": "Chandigarh",
  "05": "Uttarakhand",
  "06": "Haryana",
  "07": "Delhi",
  "08": "Rajasthan",
  "09": "Uttar Pradesh",
  "10": "Bihar",
  "11": "Sikkim",
  "12": "Arunachal Pradesh",
  "13": "Nagaland",
  "14": "Manipur",
  "15": "Mizoram",
  "16": "Tripura",
  "17": "Meghalaya",
  "18": "Assam",
  "19": "West Bengal",
  "20": "Jharkhand",
  "21": "Odisha",
  "22": "Chhattisgarh",
  "23": "Madhya Pradesh",
  "24": "Gujarat",
  "26": "Dadra and Nagar Haveli and Daman and Diu",
  "27": "Maharashtra",
  "28": "Andhra Pradesh",
  "29": "Karnataka",
  "30": "Goa",
  "31": "Lakshadweep",
  "32": "Kerala",
  "33": "Tamil Nadu",
  "34": "Puducherry",
  "35": "Andaman and Nicobar Islands",
  "36": "Telangana",
  "37": "Andhra Pradesh",
  "38": "Ladakh",
  "97": "Other Territory",
  "99": "Centre Jurisdiction",
};

/**
 * Extracts the 2-digit state code from a GSTIN.
 * @param {string} gstNumber 
 * @returns {string} 2-digit state code or empty string
 */
export const getStateCodeFromGst = (gstNumber) => {
  if (!gstNumber || typeof gstNumber !== "string") return "";
  const cleaned = gstNumber.trim();
  if (cleaned.length < 2) return "";
  return cleaned.substring(0, 2);
};

/**
 * Retrieves the State Name based on the first 2 digits of a GSTIN.
 * @param {string} gstNumber 
 * @returns {string} State name or empty string
 */
export const getStateNameFromGst = (gstNumber) => {
  const code = getStateCodeFromGst(gstNumber);
  return GST_STATE_CODES[code] || "";
};

export default GST_STATE_CODES;
